import { Dayjs } from 'dayjs';

import { Config } from '@app/config/base';
import { SDate } from '@summit/core';

import { EboNameObject } from './ebo-name-object';

export class EboObjectTimeLine extends EboNameObject {
  effectiveDate: Dayjs;

  constructor(jsonData?: Partial<EboObjectTimeLine>) {
    super(jsonData);
    if (jsonData) {
      // console.log(`Got text string ${jsonData.effectiveDate}`)
      if (jsonData.effectiveDate) this.effectiveDate = SDate.newUtc(jsonData.effectiveDate);
    }
    if (!this.effectiveDate || !this.effectiveDate.isValid()) this.effectiveDate = SDate.getNormalized();
  }

  static filterToLatest(value: any, index: number, self: Array<Partial<EboObjectTimeLine>>) {
    return self.indexOf(value) === index;
  }

  isHistorical(): boolean {
    //console.log('isHistorical', this.startTime, SDate.new().subtract(Config.timelineEditStopsAfter, 'days'));
    return this.effectiveDate.isBefore(SDate.new().subtract(Config.timelineEditStopsAfter, 'days'));
  }
}
